import init from './init';

export default () => {
  document.addEventListener('shopify:section:load', function (e) {
    const sectionId = e.detail.sectionId;
    const elements = document.querySelectorAll(`[data-section-id="${sectionId}"]`);
    elements.forEach(function (element) {
      init(element);
    });
  });
};
